import { appId } from "@kestrel/internal/client";
import * as Module from "@kestrel/client";
import * as Debug from "@otto-ec/global-resources/debug";

/**
 *
 */
export const getLogger = ((scope) => {
  const appScope = Debug.scope(appId);
  return (scope ? appScope.scope(scope) : appScope) as never;
}) satisfies typeof Module.getLogger;
